export default __webpack_public_path__ + "static/media/viavi.fbc13024.png";